import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingWhatsApp from "@/components/layout/FloatingWhatsApp";
import CodexsanBadge from "@/components/layout/CodexsanBadge";
import ScrollToTop from "@/components/layout/ScrollToTop";

import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import InciAkuPage from "@/pages/InciAkuPage";
import GalleryPage from "@/pages/GalleryPage";
import ContactPage from "@/pages/ContactPage";
import AcilAkuDegisimi from "@/pages/AcilAkuDegisimi";
import AreaAkuDegisimi from "@/pages/AreaAkuDegisimi";

function App() {
  return (
    <div className="App min-h-screen bg-[#0a0a0a] text-white">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/hakkimizda" element={<AboutPage />} />
            <Route path="/hizmetlerimiz" element={<ServicesPage />} />
            <Route path="/inci-aku" element={<InciAkuPage />} />
            <Route path="/galeri" element={<GalleryPage />} />
            <Route path="/iletisim" element={<ContactPage />} />
            <Route path="/eskisehir-acil-aku-degisimi" element={<AcilAkuDegisimi />} />
            <Route path="/tepebasi-aku-degisimi" element={<AreaAkuDegisimi />} />
            <Route path="/odunpazari-aku-degisimi" element={<AreaAkuDegisimi />} />
            <Route path="/emek-mahallesi-aku-degisimi" element={<AreaAkuDegisimi />} />
            <Route path="/batikent-aku-degisimi" element={<AreaAkuDegisimi />} />
            <Route path="/sazova-aku-degisimi" element={<AreaAkuDegisimi />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
        <FloatingWhatsApp />
        <CodexsanBadge />
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "rgba(10,10,10,0.95)",
              border: "1px solid rgba(212,175,55,0.3)",
              color: "white",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
